// fixed/updated by ChatGPT on 2025-12-04 10:41 – added Product Types → SelfProductAdminForm route link
import "./Sidebar.css";
import { Link, useLocation } from "react-router-dom";
import StoreIcon from "@mui/icons-material/Store";
import LockIcon from "@mui/icons-material/Lock";

function Sidebar() {
  const location = useLocation();

  // ORIGINAL AUTH LOGIC
  const isLoggedIn = localStorage.getItem("cc_auth") === "true";
  const role = localStorage.getItem("cc_role");
  const isAdmin = role?.toLowerCase() === "admin";

  const isActive = (path) => location.pathname.startsWith(path);

  const itemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "6px 12px",
    margin: "6px 0",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "15px",
    fontWeight: 500,
    color: "#ffd369",
  };

  const activeStyle = {
    ...itemStyle,
    backgroundColor: "#7b1a1a",
    color: "#fff",
  };

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <img src="/logo.jpg" alt="Logo" />
      </div>

      <div className="menu">
        {!isLoggedIn ? (
          <>
            <Link to="/store" style={isActive("/store") ? activeStyle : itemStyle}>
              <StoreIcon className="sidebar-icon" />
              <span>Public Store</span>
            </Link>

            <Link to="/login" style={isActive("/login") ? activeStyle : itemStyle}>
              <LockIcon className="sidebar-icon" />
              <span>Login</span>
            </Link>
          </>
        ) : (
          <>
            {/* ADMIN ONLY MENUS */}
            {isAdmin && (
              <>
                {/* OLD ITEM */}
                <Link
                  to="/upload"
                  style={isActive("/upload") ? activeStyle : itemStyle}
                >
                  <StoreIcon className="sidebar-icon" />
                  <span>Upload Self Product</span>
                </Link>

                {/* NEW: Product Types → SelfProductAdminForm */}
                <Link
                  to="/product-types"
                  style={isActive("/product-types") ? activeStyle : itemStyle}
                >
                  <StoreIcon className="sidebar-icon" />
                  <span>Product Types</span>
                </Link>
              </>
            )}

            {/* COMMON MENUS */}
            <Link
              to="/orders"
              style={isActive("/orders") ? activeStyle : itemStyle}
            >
              <StoreIcon className="sidebar-icon" />
              <span>Orders</span>
            </Link>

            <Link
              to="/shop"
              style={isActive("/shop") ? activeStyle : itemStyle}
            >
              <StoreIcon className="sidebar-icon" />
              <span>Shop View</span>
            </Link>
          </>
        )}

        {/* LOGOUT */}
        {isLoggedIn && (
          <div className="menu-bottom" style={{ marginTop: "20px" }}>
            <Link
              to="#"
              onClick={() => {
                localStorage.clear();
                window.location.href = "/login";
              }}
              style={itemStyle}
            >
              <LockIcon className="sidebar-icon" />
              <span>Logout</span>
            </Link>
          </div>
        )}
      </div>
    </aside>
  );
}

export default Sidebar;
